/**
 * @author  : 王冲
 * @desc    : 重登弹框
 */

import { Component } from 'react';
import { inject, observer } from 'mobx-react';

import { getLabel } from '@weapp/utils';
import {
  Dialog, Button, Input, Icon
} from '@weapp/ui';

import { mainClsPrefix, DIALOG_BASE_WIDTH, DIALOG_BASE_TOP } from "../../constants";
// import { clearTeamsCookie } from "../../utils";
import { ReloginDialogProps } from './types';

import './style/index.less';
const baseClassName = `${mainClsPrefix}-relogin`;
// const { Password } = Input;
@inject('reloginStore')
@observer
class ReloginDialog extends Component<ReloginDialogProps, any> {
  state = {
    visible: true,
    passwordOpen: false
  }
  componentDidMount() {
    //检测冻结与离职状态
    this.props.reloginStore?.init();
  }
  onLoginParamsChange = (type: string, value: string) => {
    let { loginParams } = this.props.reloginStore!;
    let params = { ...loginParams };
    //@ts-ignore
    params[type] = value.trim();
    this.props.reloginStore?.updateLoginParams(params);
  }
  relogin = () => {
    // const { tgt } = this.props.reloginStore!;

    // if (!tgt) {
    this.props.reloginStore?.relogin();
    // }
  }
  changePasswordOpenState = () => {
    this.setState({
      passwordOpen: !this.state.passwordOpen
    })
  }
  renderContent = () => {
    const { message,
      // canReload, statusChecked
    } = this.props.reloginStore!;
    const { passwordOpen } = this.state;
    const { username, password } = this.props.reloginStore?.loginParams!;
    /* eslint-disable */
    return (
      // statusChecked &&
      <div className={`${baseClassName}`}>
        <div className={`${baseClassName}-tip`}>
          {message}
        </div>
        {
          // canReload ? (
          <div className={`${baseClassName}-form`}>
            <div className={`${baseClassName}-form-item`}>
              <div className={`${baseClassName}-form-item-label`}>{getLabel('72803', '用户名')} :</div>
              <div className={`${baseClassName}-form-item-content`}>
                <Input placeholder={getLabel('80366', '请输入用户名')} value={username} onChange={(value) => this.onLoginParamsChange('username', value as string)} />
              </div>
            </div>
            <div className={`${baseClassName}-form-item`}>
              <div className={`${baseClassName}-form-item-label`}>{getLabel('72804', '密码')}:</div>
              <div className={`${baseClassName}-form-item-content`}>
                <Input
                  placeholder={getLabel('80367', '请输入密码')}
                  type={passwordOpen ? `text` : `password`}
                  value={password}
                  onChange={(value) => this.onLoginParamsChange('password', value as string)}
                  suffix={<div className={`${baseClassName}-form-item-suffix`}><Icon onClick={this.changePasswordOpenState} name={`${passwordOpen ? `Icon-Open-password02` : `Icon-Close-password`}`}></Icon></div>}
                />
              </div>
            </div>
          </div>
          // )
          // : <div className={`${baseClassName}-passport`}>
          //   <Button onClick={this.toPassport}>{getLabel('80349', '返回登录页')}</Button>
          // </div>
        }
      </div>
    )
    /* eslint-disable */

  }
  renderButtons = () => {
    // const { canReload, statusChecked } = this.props.reloginStore!;
    return (
      // statusChecked && canReload &&
      <Button type="primary" onClick={this.relogin}>{getLabel('80350', '重新登录')}</Button>
    )
  }
  renderTitle = () => {
    return (
      <div className={`${baseClassName}-title`}>{getLabel('80350', '重新登录')}<span>（{getLabel('80351', '重登会丢失未保存的数据，请先复制保存')}！）</span></div>
    )
  }
  handleClose = () => {
    const dialog = document.querySelector('#reloginDialog');
    if (dialog && dialog.parentNode) {
      dialog.parentNode.removeChild(dialog);
    }
    this.setState({ visible: false });
    delete window.layoutIsShowRelogin

  }
  // toPassport = () => {
  //   clearTeamsCookie();
  //   window.location.href = window.TEAMS?.passportUrl + '/logout?service=' + encodeURIComponent(window.location.origin);
  // }
  render() {

    return (

      this.state.visible && <Dialog weId={`${this.props.weId || ''}_6j0sof`}
        visible={true}
        onClose={this.handleClose}
        closable
        getTitleLabel={this.renderTitle}
        destroyOnClose
        mask
        // maskClosable
        width={DIALOG_BASE_WIDTH}
        top={DIALOG_BASE_TOP}
        height={300}
        leftCol={22}
        rightCol={2}
        className={`${baseClassName}-dialog`}
        icon="Icon-group-o"
        footer={[this.renderButtons()]}
      >
        {this.renderContent()}
      </Dialog>

    )
  }
}

export default ReloginDialog;
